/**
 * home
 */
 import img_01 from '../../assets/img/home/one/img_01.jpg';
 import img_02 from '../../assets/img/home/one/img_02.jpg';
 import img_03 from '../../assets/img/home/one/img_03.jpg';
 import titlepc from '../../assets/img/home/one/titlepc.svg';
 import titlem from '../../assets/img/home/one/titlem.svg';

 import domesticImg1 from '../../assets/img/home/four/domesticImg1.jpg';
 import domesticImg2 from '../../assets/img/home/four/domesticImg2.jpg';
 import domesticImg3 from '../../assets/img/home/four/domesticImg3.jpg';
 import domesticImg4 from '../../assets/img/home/four/domesticImg4.jpg';


import img1 from '../../assets/img/home/fives/img1.jpg';
import img2 from '../../assets/img/home/fives/img2.jpg';
import img3 from '../../assets/img/home/fives/img3.jpg';
import img4 from '../../assets/img/home/fives/img4.jpg';

import icon1 from '../../assets/img/home/fives/icon/icon1.svg';
import icon2 from '../../assets/img/home/fives/icon/icon2.svg';
import icon3 from '../../assets/img/home/fives/icon/icon3.svg';

import iconm1 from '../../assets/img/home/fives/icon/Iconm1.svg';
import iconm2 from '../../assets/img/home/fives/icon/Iconm2.svg';
import iconm3 from '../../assets/img/home/fives/icon/Iconm3.svg';



/**
 * travelMall
 */

// 国内游
import tm_xiamen from '../../assets/img/travelmall/domesticTour/tm_xiamen.jpg';
import tm_chengdu from '../../assets/img/travelmall/domesticTour/tm_chengdu.jpg';
import tm_beihai from '../../assets/img/travelmall/domesticTour/tm_beihai.jpg';
import tm_wanning from '../../assets/img/travelmall/domesticTour/tm_wanning.jpg';
import tm_mongolia from '../../assets/img/travelmall/domesticTour/tm_mongolia.jpg';
import tm_tibet from '../../assets/img/travelmall/domesticTour/tm_tibet.jpg';

import xiamen01 from '../../assets/img/travelmall/domesticTour/tm_xiamen/xiamen01.jpg';
import xiamen02 from '../../assets/img/travelmall/domesticTour/tm_xiamen/xiamen02.jpg';
import xiamen03 from '../../assets/img/travelmall/domesticTour/tm_xiamen/xiamen03.jpg';

import chengdu01 from '../../assets/img/travelmall/domesticTour/tm_chengdu/chengdu01.jpg';
import chengdu02 from '../../assets/img/travelmall/domesticTour/tm_chengdu/chengdu02.jpg';
import chengdu03 from '../../assets/img/travelmall/domesticTour/tm_chengdu/chengdu03.jpg';

import beihai01 from '../../assets/img/travelmall/domesticTour/tm_beihai/beihai01.jpg';
import beihai02 from '../../assets/img/travelmall/domesticTour/tm_beihai/beihai02.jpg';
import beihai03 from '../../assets/img/travelmall/domesticTour/tm_beihai/beihai03.jpg';

import wanning01 from '../../assets/img/travelmall/domesticTour/tm_wanning/wanning01.jpg';
import wanning02 from '../../assets/img/travelmall/domesticTour/tm_wanning/wanning02.jpg';
import wanning03 from '../../assets/img/travelmall/domesticTour/tm_wanning/wanning03.jpg';

import mongolia01 from '../../assets/img/travelmall/domesticTour/tm_mongolia/mongolia01.jpg';
import mongolia02 from '../../assets/img/travelmall/domesticTour/tm_mongolia/mongolia02.jpg';
import mongolia03 from '../../assets/img/travelmall/domesticTour/tm_mongolia/mongolia03.jpg';

import tibet01 from '../../assets/img/travelmall/domesticTour/tm_tibet/tibet01.jpg';
import tibet02 from '../../assets/img/travelmall/domesticTour/tm_tibet/tibet02.jpg';
import tibet03 from '../../assets/img/travelmall/domesticTour/tm_tibet/tibet03.jpg';



// 境外游
import tm_egypt from '../../assets/img/travelmall/overseasTour/tm_egypt.jpg';
import tm_japan from '../../assets/img/travelmall/overseasTour/tm_japan.jpg';
import tm_finland from '../../assets/img/travelmall/overseasTour/tm_finland.jpg';
import tm_bali from '../../assets/img/travelmall/overseasTour/tm_bali.jpg';
import tm_madagascar from '../../assets/img/travelmall/overseasTour/tm_madagascar.jpg';
import tm_antarctica from '../../assets/img/travelmall/overseasTour/tm_antarctica.jpg';

import egypt01 from '../../assets/img/travelmall/overseasTour/tm_egypt/egypt01.jpg';
import egypt02 from '../../assets/img/travelmall/overseasTour/tm_egypt/egypt02.jpg';
import egypt03 from '../../assets/img/travelmall/overseasTour/tm_egypt/egypt03.jpg';

import japan01 from '../../assets/img/travelmall/overseasTour/tm_japan/japan01.jpg';
import japan02 from '../../assets/img/travelmall/overseasTour/tm_japan/japan02.jpg';
import japan03 from '../../assets/img/travelmall/overseasTour/tm_japan/japan03.jpg';

import finland01 from '../../assets/img/travelmall/overseasTour/tm_finland/finland01.jpg';
import finland02 from '../../assets/img/travelmall/overseasTour/tm_finland/finland02.jpg';
import finland03 from '../../assets/img/travelmall/overseasTour/tm_finland/finland03.jpg';

import bali01 from '../../assets/img/travelmall/overseasTour/tm_bali/bali01.jpg';
import bali02 from '../../assets/img/travelmall/overseasTour/tm_bali/bali02.jpg';
import bali03 from '../../assets/img/travelmall/overseasTour/tm_bali/bali03.jpg';

import madagascar01 from '../../assets/img/travelmall/overseasTour/tm_madagascar/madagascar01.jpg';
import madagascar02 from '../../assets/img/travelmall/overseasTour/tm_madagascar/madagascar02.jpg';
import madagascar03 from '../../assets/img/travelmall/overseasTour/tm_madagascar/madagascar03.jpg';

import antarctica01 from '../../assets/img/travelmall/overseasTour/tm_antarctica/antarctica01.jpg';
import antarctica02 from '../../assets/img/travelmall/overseasTour/tm_antarctica/antarctica02.jpg';
import antarctica03 from '../../assets/img/travelmall/overseasTour/tm_antarctica/antarctica03.jpg';

// 全部服务
import frame_1 from '../../assets/img/public/icons/frame_1.svg';
import frame_2 from '../../assets/img/public/icons/frame_2.svg';
import frame_3 from '../../assets/img/public/icons/frame_3.svg';
import frame_4 from '../../assets/img/public/icons/frame_4.svg';
import frame_5 from '../../assets/img/public/icons/frame_5.svg';
import frame_6 from '../../assets/img/public/icons/frame_6.svg';
import frame_7 from '../../assets/img/public/icons/frame_7.svg';
import frame_8 from '../../assets/img/public/icons/frame_8.svg';

// 主题游
import tm_family from '../../assets/img/travelmall/themeTour/tm_family.jpg';
import tm_honeymoon from '../../assets/img/travelmall/themeTour/tm_honeymoon.jpg';
import tm_island from '../../assets/img/travelmall/themeTour/tm_island.jpg';
import tm_culture from '../../assets/img/travelmall/themeTour/tm_culture.jpg';
import tm_adventure from '../../assets/img/travelmall/themeTour/tm_adventure.jpg';
import tm_luxury from '../../assets/img/travelmall/themeTour/tm_luxury.jpg';

// 公用图标
import cat_1 from '../../assets/img/travelmall/icons/cat_1.svg';
import cat_2 from '../../assets/img/travelmall/icons/cat_2.svg';
import cat_3 from '../../assets/img/travelmall/icons/cat_3.svg';
import cat_4 from '../../assets/img/travelmall/icons/cat_4.svg';
import cat_5 from '../../assets/img/travelmall/icons/cat_5.svg';
import cat_6 from '../../assets/img/travelmall/icons/cat_6.svg';

import markMap from '../../assets/img/public/icons/markMapg.svg';
import markMapw from '../../assets/img/public/icons/markMap.svg';
import basicModal1 from '../../assets/img/travelmall/basicModal/icons/v1.svg';
import basicModal2 from '../../assets/img/travelmall/basicModal/icons/v2.svg';

import serviceIcon_1 from '../../assets/img/travelmall/basicModal/icons/serviceIcon_1.svg';
import serviceIcon_2 from '../../assets/img/travelmall/basicModal/icons/serviceIcon_2.svg';
import serviceIcon_3 from '../../assets/img/travelmall/basicModal/icons/serviceIcon_3.svg';

import pcbg from '../../assets/img/travelmall/basicModal/pcbg.jpg';
import pcbgn from '../../assets/img/travelmall/basicModal/pcbgn.jpg';

import q1 from '../../assets/img/travelmall/basicModal/faqico/q1.svg';
import q2 from '../../assets/img/travelmall/basicModal/faqico/q2.svg';
import q3 from '../../assets/img/travelmall/basicModal/faqico/q3.svg';
import q4 from '../../assets/img/travelmall/basicModal/faqico/q4.svg';
import q5 from '../../assets/img/travelmall/basicModal/faqico/q5.svg';
import q6 from '../../assets/img/travelmall/basicModal/faqico/q6.svg';
import q7 from '../../assets/img/travelmall/basicModal/faqico/q7.svg';


// customTravel
import customizedtravel from '../../assets/img/customtravel/banner/customizedtravel.jpg';
import customizedtravelm from '../../assets/img/customtravel/banner/customizedtravelm.jpg';

import ct_image01 from '../../assets/img/customtravel/imgs/ct_image01.jpg';
import ct_image02 from '../../assets/img/customtravel/imgs/ct_image02.jpg';
import ct_image03 from '../../assets/img/customtravel/imgs/ct_image03.jpg';

import whychoose_bg from '../../assets/img/customtravel/imgs/whychoose_bg.jpg';
import whychoose_bgm from '../../assets/img/customtravel/imgs/whychoose_bgm.jpg';

import customtravelIcon1 from '../../assets/img/customtravel/icons/1.svg';
import customtravelIcon2 from '../../assets/img/customtravel/icons/2.svg';
import customtravelIcon3 from '../../assets/img/customtravel/icons/3.svg';
import customtravelIcon4 from '../../assets/img/customtravel/icons/4.svg';

// aboutUs
import au_image01 from '../../assets/img/aboutUs/imgs/au_image01.jpg';
import au_image02 from '../../assets/img/aboutUs/imgs/au_image02.jpg';
import philosophy_img from '../../assets/img/aboutUs/imgs/philosophy_img.jpg';
import philosophy_imgm from '../../assets/img/aboutUs/imgs/philosophy_imgm.jpg';


import d1Icon from '../../assets/img/travelmall/basicModal/icons/d1.svg';
import d2Icon from '../../assets/img/travelmall/basicModal/icons/d2.svg';


// global config file start
const {
  websiteRecord, // 网站备案/版权
  companyName, // 公司名字
  abbreviation, // 简称->中文
  companyAddress,  // 公司地址->中文
  contactInformation, // 联系方式
} = window.globalConfig;
// global config file end

const zhCN = {
  'lang': '中文',
  home: {
    videoDisplayData: [
      {
        id: 1001,
        titlep: titlepc,
        titlem: titlem,
        desc: `鼎盛新境界，游你更精彩`,
        img: img_01,
      },
      /* {
        id: 1002,
        titlep: titlepc,
        titlem: titlem,
        desc: `品味扶桑，全面领略日本风土`,
        img: img_02,
      },
      {
        id: 1003,
        titlep: titlepc,
        titlem: titlem,
        desc: `梦幻玻璃屋套房，躺在床上赏极光`,
        img: img_03,
      }, */
    ],
    twoPage: {
      content: {
        title: '鼎盛旅游，鼎盛世界',
        desc: `${companyName.fullNameZH}成立于2016年，是国内专业的综合性旅游服务商。我们推崇与众不同的度假理念，提供包括入境游、出境游、旅游定制、酒店预订等服务、出行服务。在港澳游、东南亚出境游、日韩出境游上具有较强的竞争优势，一直以优秀的旅游品质，诚信的服务赢得海内外客户的称赞。`,
      }
    },
    threePage: {
      serviceAdvantagesData: [
        {
          id: 1001,
          title: '服务优势',
          subTitle: '实地勘察：网红景点打卡大感失望？攻略和实际差距太大？',
          desc: '42个国家定制旅游路线实地考察，注重挖掘当地文化生活。'
        },
        {
          id: 1002,
          title: '服务优势',
          subTitle: `出行无忧：语言不通，沟通困难？突发状况不知如何处理？`,
          desc: `7×24管家服务，航空、酒店、保安、司导一应俱全。`
        },
        {
          id: 1003,
          title: '服务优势',
          subTitle: `私人定制：查资料、看攻略、办签证，旅行准备烦琐头疼？`,
          desc: `量身定制行程，满足您不同场景下的个性化需求。`
        },
        {
          id: 1004,
          title: '服务优势',
          subTitle: `超值体验：厌倦千篇一律？想感受不一样的旅行体验？`,
          desc: `独家资源，满足您的要求，超出您的想象。`
        },
      ]
    },
    fourPage: {
      morepTitle: '国内推荐',
      domesticSelectionData: [
        {
          id: 1001,
          num: 4,
          index: 3, 
          title: '万宁',
          subTitle: '四季温暖如春，玻璃般透明晶莹的海水',
          img: domesticImg1,
        },
        {
          id: 1002,
          num: 5,
          index: 4, 
          title: '内蒙古',
          subTitle: '欣赏最迷人的草原自然风光',
          img: domesticImg2,
        },
        {
          id: 1003,
          num: 6,
          index: 1,
          title: '成都',
          subTitle: '遛娃必去，慵懒小时光，看软萌大熊猫',
          img: domesticImg3,
        },
        {
          id: 1004,
          num: 7,
          index: 5, 
          title: '西藏',
          subTitle: '藏地江南，神圣之旅，寻觅不一样的拉萨',
          img: domesticImg4,
        },
      ]
    },
    fivesPage: {
      morepTitle: '境外推荐',
      overseasSelectionData: [
        {
          id: 1001,
          title: '慢游关西初体验',
          subTitle: '大阪的现代，京都和奈良的古朴宁静',
          // subTitle: '大阪的现代，京都和奈良的古朴宁静，在这样的行程里会让你沉浸在日本的自然美景，美食和文化中，在城市与古城之间穿梭。',
          address: '日本',
          img: img1,
          icon: markMapw,
        },
        {
          id: 1002,
          title: '自然之美',
          subTitle: '与现代化都市完美结合',
          // subTitle: '你可以踏上欢乐圣地圣淘沙岛玩遍数不尽数的游乐项目，也可以奔向拥有百余家商场的乌节路血拼购物。位于北部雨林中的日夜间动物园则是亲子游的首选。夜幕降临下的滨海湾，更是与地标金沙酒店和鱼尾狮像合影的好时机，搭上全球最高的飞行者摩天轮还能将整个滨海湾尽收眼底。',
          address: '新加坡',
          img: img2,
          icon: markMapw,
        },
        {
          id: 1003,
          title: '撒哈拉',
          subTitle: `满足你对沙漠的所有憧憬`,
          // subTitle: `一半海水、一半沙漠，摩洛哥的美远比你想象的还要多，大西洋边绵延千里的迷人海岸线，马拉喀什多彩老城的热气球。在撒哈拉沙漠里越野车冲沙，骑骆驼沿着日落前行，在沙丘上看夕阳，在帐篷外仰望漫天星空，它能满足你对旅行的一切憧憬。`,
          address: '摩洛哥',
          img: img3,
          icon: markMapw,
        },
        {
          id: 1004,
          title: '西班牙',
          subTitle: '伊比利亚半岛的艳阳下',
          // subTitle: '热情奔放的弗拉门戈，英勇无畏的斗牛士，耀目阳光下的西班牙。高耸的比利牛斯山脉阻断了欧洲大陆南下的冷空气，也造就了独一无二的西班牙——张扬，热烈，痛快淋漓。',
          address: '西班牙',
          img: img4,
          icon: markMapw,
        },
      ]
    },
    sixPage: {
      statisticsInner: {
        since: '自 2016 年,',
        total: '284,301',
        customers: '位客户',
      },
      choose: '选择了鼎盛旅游',
    }
  },
  travelMall: {
    bannerBtnText: '最美的风景，一直在路上',
    domesticTour: {
      title: '国内游',
      list: [
        {
          id: 1001,
          title: '海上花园',
          people: '/人',
          address: '厦门',
          days: '5日',
          group: '奔向海岛',
          total: '累计74人出行',
          money: '1,699',
          img: tm_xiamen,
          icon: cat_4,
          markMap: markMap,
          content: [
            {
              key: 1001,
              desc: `经典景点，鼓浪屿、云水谣土楼，轻松打卡！安排1日住岛，好玩不累！`,
            },
            {
              key: 1002,
              desc: `厦门独有的闽南文化让这座城有别于其他地方，从建筑风格、人文历史到地方美食，特有的闽南味道，让你体会与平日里完全不同的生活气息，也让你对这座城增添更多兴致。`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: xiamen01,
            },
            {
              id: 'B1002',
              img: xiamen02,
            },
            {
              id: 'B1003',
              img: xiamen03,
            },
          ],
          newTravelItinerary: {
            title: '行程方案',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: '抵达厦门',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '第八海鲜市场',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '抵达厦门',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: '云水谣古镇',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '怀远楼',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '和贵楼',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '云水谣古镇',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: '钟鼓索道',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '南普陀寺',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '前往鼓浪屿',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '钟鼓索道',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: '日光岩',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '菽庄花园',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '返程',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '日光岩',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1002,
          title: '熊猫宝宝',
          people: '/人',
          address: '成都',
          days: '4日',
          group: '家庭亲子',
          total: '累计160人出行',
          img: tm_chengdu,
          icon: cat_1,
          markMap: markMap,
          money: '1,499',
          content: [
            {
              key: 1001,
              desc: `遛娃必去，慵懒小时光，看软萌大熊猫。`,
            },
            {
              key: 1002,
              desc: `急不忙，不骄不躁，放下生活和工作的重担，在旅行中找回自己原本最美的样子。`,
            },
            {
              key: 1003,
              desc: `最美的时光，最好的年纪，最好的旅行送给最爱的自己和家人。`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: chengdu01,
            },
            {
              id: 'B1002',
              img: chengdu02,
            },
            {
              id: 'B1003',
              img: chengdu03,
            },
          ],
          newTravelItinerary: {
            title: '行程方案',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: '抵达成都',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '春熙路',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '成都远洋太古里',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: '方所书店',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '抵达成都',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: '成都大熊猫繁育基地',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '宽窄巷子',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '小通巷',
                  },
                  {
                    key: 1006,
                    name: '奎星楼街',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '成都大熊猫繁育基地',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: '杜甫草堂',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '武侯祠',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '锦里',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '杜甫草堂',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: '成都',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '返程',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '成都',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1003,
          title: '北海+涠洲岛',
          people: '/人',
          address: '北海',
          days: '4日',
          group: '奔向海岛',
          total: '累计35人出行',
          img: tm_beihai,
          icon: cat_2,
          markMap: markMap,
          money: '1,499',
          content: [
            {
              key: 1001,
              desc: `北海，一个住下就不想走的城市，感受阳光沙滩，一线海景看夕阳，INS海岛度假风民宿。`,
            },
            {
              key: 1002,
              desc: `细软的洁白沙滩世界上数一数二，海水清澈见底，鱼儿自由自在。到了晚上，你将欣赏到世界上最迷人最干净的星空，品尝过最好吃的海鲜和各种水果。`,
            },
            {
              key: 1003,
              desc: `在这里，您将忘记所有烦恼，只剩下简单，纯粹、快乐的时光。`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: beihai01,
            },
            {
              id: 'B1002',
              img: beihai02,
            },
            {
              id: 'B1003',
              img: beihai03,
            },
          ],
          newTravelItinerary: {
            title: '行程方案',
            list: [
              {
                id: 'D1',
                address: [ 
                  {
                    key: 1001,
                    name: '抵达北海',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '北海银滩旅游度假区',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '北海海底世界',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '抵达北海',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [ // → → 
                  {
                    key: 1001,
                    name: '北海',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '涠洲岛五彩滩',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '涠洲盛塘天主教堂',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '北海',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: '涠洲岛',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '滴水丹屏',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '涠洲岛',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: '北海',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '返程',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '北海',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1004,
          title: '在温暖的海岛晒太阳',
          people: '/人',
          address: '万宁',
          days: '5日',
          group: '奔向海岛',
          total: '累计35人出行',
          img: tm_wanning,
          icon: cat_2,
          markMap: markMap,
          money: '1,999',
          content: [
            {
              key: 1001,
              desc: `这里四季温暖如春，玻璃般透明晶莹的海水，在这你可以无所事事地望着大海远处凝思，静待日落天亮。`,
            },
            {
              key: 1002,
              desc: `探索奇趣Young生活，掌握冲浪技能，探秘加井岛浮潜，新潮海岛度假风。各种丰富的岛上活动，拖伞（滑翔伞）、飞鱼、摩托艇双人、海底漫步、香蕉船、珊瑚礁浮潜、旅拍等，帮您一探“人间仙境”的美景！`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: wanning01,
            },
            {
              id: 'B1002',
              img: wanning02,
            },
            {
              id: 'B1003',
              img: wanning03,
            },
          ],
          newTravelItinerary: {
            title: '行程方案',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: '抵达海口',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '万宁',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '抵达海口',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: '石梅湾/日月湾冲浪',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '兴隆热带植物园',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '巴厘村',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '石梅湾/日月湾冲浪',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: '石梅湾加井岛',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '石梅湾加井岛',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: '凤凰九里书屋',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '神州半岛',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '东山岭文化旅游区',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '凤凰九里书屋',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: '万宁',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '海口',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '返程',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '万宁',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1005,
          title: '行摄之旅-内蒙古草原季',
          people: '/人',
          address: '内蒙古',
          days: '6日',
          group: '自然风景',
          total: '累计35人出行',
          img: tm_mongolia,
          icon: cat_3,
          markMap: markMap,
          money: '3,999',
          content: [
            {
              key: 1001,
              desc: `内蒙古呼伦贝尔+满洲里+额尔古纳让您一次玩个够！`,
            },
            {
              key: 1002,
              desc: `微风卷绿浪的呼伦贝尔，你将欣赏到最迷人的草原自然风光。`,
            },
            {
              key: 1003,
              desc: `微风卷绿浪的呼伦贝尔，你将欣赏到最迷人的草原自然风光。一望无垠的大草原、蔚蓝的天空、最干净迷人的星空。`,
            },
            {
              key: 1004,
              desc: `一路的五彩缤纷的花儿，处处皆是明信片般的风景。`,
            },
            {
              key: 1005,
              desc: `那里牛羊成群，绿草如茵、五彩的花儿开满遍地。`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: mongolia01,
            },
            {
              id: 'B1002',
              img: mongolia02,
            },
            {
              id: 'B1003',
              img: mongolia03,
            },
          ],
          newTravelItinerary: {
            title: '行程方案',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: '抵达海拉尔',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '抵达海拉尔',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: '呼伦贝尔大草原',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '额尔古纳国家湿地公园',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '呼伦贝尔大草原',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: '呼伦贝尔黑山头骏驰马场（不限时骑马穿越草原）',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '额吉故乡',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '边防公路',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '呼伦贝尔黑山头骏驰马场（不限时骑马穿越草原）',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: '巴尔虎蒙古部落民俗旅游度假景区',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '满洲里套娃景区',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '满洲里',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: '中苏金街步行街',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '巴尔虎蒙古部落民俗旅游度假景区',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: '满洲里国门景区',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '呼伦湖',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '呼和诺尔草原旅游区',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '满洲里国门景区',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D6',
                address: [
                  {
                    key: 1001,
                    name: '海拉尔',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '返程',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '海拉尔',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1006,
          title: '西藏初体验-林芝拉萨',
          people: '/人',
          address: '西藏',
          days: '7日',
          group: '自然风景',
          total: '累计35人出行',
          img: tm_tibet,
          icon: cat_4,
          markMap: markMap,
          money: '3,999',
          content: [
            {
              key: 1001,
              desc: `藏地江南，神圣之旅，寻觅不一样的拉萨。`,
            },
            {
              key: 1002,
              desc: `谷深林密的巴松错区域和大峡谷区域，精灵国度的冷云杉林，碧玉裁成般的溪流，直挂蓝天的飞瀑，牛马成群的隐秘牧场。一生难忘的雪峰夕照。`,
            },
            {
              key: 1003,
              desc: `一路穿行在冰川、湖泊、溪流、瀑布、牧场、峡谷、原始森林、草原等不同形态的自然造物神奇之中。`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: tibet01,
            },
            {
              id: 'B1002',
              img: tibet02,
            },
            {
              id: 'B1003',
              img: tibet03,
            },
          ],
          newTravelItinerary: {
            title: '行程方案',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: '抵达林芝',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '雅鲁藏布江',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '索松村',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '抵达林芝',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: '雅鲁藏布江',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '额尔古纳国家湿地公园',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '鲁朗林海',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: '扎西岗村',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '雅鲁藏布江',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: '林芝',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '巴松措',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '嘎拉桃花村',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '林芝',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: '巴松措',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '拉萨',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '巴松措',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: '拉萨',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '山南',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '羊卓雍错',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '拉萨',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D6',
                address: [
                  {
                    key: 1001,
                    name: '拉萨',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '布达拉宫',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '大昭寺',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: '八廓街',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '拉萨',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D7',
                address: [
                  {
                    key: 1001,
                    name: '拉萨',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '返程',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '拉萨',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
      ],
    },
    overseasTour: {
      title: '境外游',
      list: [
        {
          id: 1001,
          title: '追寻法老足迹探秘千年历史',
          people: '/人',
          address: '埃及',
          days: '7日',
          group: '世界宝藏',
          total: '累计9人出行',
          money: '19,999',
          img: tm_egypt,
          icon: cat_4,
          markMap: markMap,
          content: [
            {
              key: 1001,
              desc: `历史的长河翻卷着淌过千年的岁月，古埃及是历史长河中最迷人的地方之一。`,
            },
            {
              key: 1002,
              desc: `特色体验：`,
            },
            {
              key: 1003,
              desc: `★官方向导带领进入金字塔内部，探索人类未解之谜。`,
            },
            {
              key: 1004,
              desc: `★乘坐风帆船醉倒在尼罗河上，欣赏壮美的日落绝景，享受尼罗河的美景。`,
            },
            {
              key: 1005,
              desc: `★乘坐卢克索特色马车巡游古城，贴近真实的埃及生活。`,
            },
            {
              key: 1006,
              desc: `★浪漫海底玻璃船巡游，探秘美丽的海底世界。`,
            },
            {
              key: 1007,
              desc: `★乘坐沙漠摩托狂野冲沙，享受赫尔格达沙漠日落绝景。`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: egypt01,
            },
            {
              id: 'B1002',
              img: egypt02,
            },
            {
              id: 'B1003',
              img: egypt03,
            },
          ],
          newTravelItinerary: {
            title: '行程方案',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: '开罗',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '阿斯旺',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '开罗',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: '阿斯旺',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '科翁坡',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '阿斯旺',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: '艾德福',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '艾德福',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: '卢克索',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '赫尔格达',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '卢克索',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: '赫尔格达',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '赫尔格达',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D6',
                address: [
                  {
                    key: 1001,
                    name: '赫尔格达',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '赫尔格达',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D7',
                address: [
                  {
                    key: 1001,
                    name: '赫尔格达',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '开罗',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '赫尔格达',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D8',
                address: [
                  {
                    key: 1001,
                    name: '开罗',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '开罗',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D9',
                address: [
                  {
                    key: 1001,
                    name: '开罗',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '送机',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '开罗',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1002,
          title: '日本樱花季',
          people: '/人',
          address: '日本',
          days: '5日',
          group: '自然风景',
          total: '累计83人出行',
          img: tm_japan,
          icon: cat_1,
          markMap: markMap,
          money: '9,999',
          content: [
            {
              key: 1001,
              desc: `追逐关西最美的樱花圣地，无限风光，这里的城楼历经数百年，依旧洁白如雪，壮观依旧。`,
            },
            {
              key: 1002,
              desc: `樱花和洁白的城楼相互映寸，没有比这更让人沉醉和美好的了。一路赏美景、品地道美食、丰富的手作体验，入住百年传统温泉旅馆，庭院内樱花盛开，赏夜樱、观星空、泡温泉。`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: japan01,
            },
            {
              id: 'B1002',
              img: japan02,
            },
            {
              id: 'B1003',
              img: japan03,
            },
          ],
          newTravelItinerary: {
            title: '行程方案',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: '伏见稻荷大社',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '京都锦市场',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '先斗町',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: '鸭川',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '伏见稻荷大社',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: '清水寺',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '三年坂二年坂',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '八坂神社',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: '圆山公园',
                  },
                  {
                    key: 1008,
                    name: ' → ',
                  },
                  {
                    key: 1009,
                    name: '祇园',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '清水寺',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: '三十三间堂',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '金阁寺',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '龙安寺',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: '京都二条城',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '三十三间堂',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: '银阁寺',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '哲学之道',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '蹴上倾斜铁道',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: '醍醐寺',
                  },
                  {
                    key: 1008,
                    name: ' → ',
                  },
                  {
                    key: 1009,
                    name: '平安神宫',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '银阁寺',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: '嵯峨野竹林',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '野宫神社',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '天龙寺',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: '岚山嵯峨野观光小火车',
                  },
                  {
                    key: 1008,
                    name: ' → ',
                  },
                  {
                    key: 1009,
                    name: '渡月桥',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '嵯峨野竹林',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1003,
          title: '梦幻玻璃屋里看极光',
          people: '/人',
          address: '芬兰',
          days: '9日',
          group: '自然风景',
          total: '累计17人出行',
          img: tm_finland,
          icon: cat_3,
          markMap: markMap,
          money: '19,999',
          content: [
            {
              key: 1001,
              desc: `★梦幻玻璃屋套房，躺在床上赏极光`,
            },
            {
              key: 1002,
              desc: `★圣诞老人村拜访世界唯一圣诞老人`,
            },
            {
              key: 1003,
              desc: `★冰雪堡垒中感受传统芬兰烟薰式桑拿屋`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: finland01,
            },
            {
              id: 'B1002',
              img: finland02,
            },
            {
              id: 'B1003',
              img: finland03,
            },
          ],
          newTravelItinerary: {
            title: '行程方案',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: '情人崖',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '神鹰广场',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '海神庙',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '情人崖',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: '蓝梦岛',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '蓝梦岛',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: '阿勇河漂流',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '金巴兰海滩',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '阿勇河漂流',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [

                  {
                    key: 1001,
                    name: '圣泉寺',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '德格拉郎梯田',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '乌布皇宫',
                  },
                  {
                    key: 1006,
                    name: ' → ',
                  },
                  {
                    key: 1007,
                    name: '乌布市场',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '圣泉寺',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: '太阳百货',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '太阳百货',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1004,
          title: '这里有世界上最美的落日',
          people: '/人',
          address: '巴厘岛',
          days: '5日',
          group: '自然风景',
          total: '累计52人出行',
          img: tm_bali,
          icon: cat_2,
          markMap: markMap,
          money: '6,999',
          content: [
            {
              key: 1001,
              desc: `清澈蔚蓝的海洋，白色的沙滩，摇曳的椰子树，自然纯净的海洋和河流。逃离人烟，远离喧嚣与人潮，独享你们的私密时光，在这里不会被外界的一切打扰。`,
            },
            {
              key: 1002,
              desc: `除路刺激的水上活动和美不胜收的自然风景，您还可以直接在私人海滩或岛屿后面浮潜，体验令人难以置信的海洋生物和丰富多彩的珊瑚。`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: bali01,
            },
            {
              id: 'B1002',
              img: bali02,
            },
            {
              id: 'B1003',
              img: bali03,
            },
          ],
          newTravelItinerary: {
            title: '行程方案',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: '情人崖',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '神鹰广场',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '海神庙',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '情人崖',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: '赫尔辛基',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '赫尔辛基',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: '赫尔辛基',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '罗瓦涅米',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '赫尔辛基',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: '罗瓦涅米',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '罗瓦涅米',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: '罗瓦涅米',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '凯米',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '罗瓦涅米',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '罗瓦涅米',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D6',
                address: [
                  {
                    key: 1001,
                    name: '罗瓦涅米',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '萨利色尔卡',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '罗瓦涅米',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D7',
                address: [
                  {
                    key: 1001,
                    name: '萨利色尔卡',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '伊瓦洛',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '萨利色尔卡',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D8',
                address: [
                  {
                    key: 1001,
                    name: '伊瓦洛',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '伊瓦洛',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D9',
                address: [
                  {
                    key: 1001,
                    name: '伊瓦洛',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '赫尔辛基',
                  },
                  {
                    key: 1004,
                    name: ' → ',
                  },
                  {
                    key: 1005,
                    name: '中国',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '伊瓦洛',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1005,
          title: '被时间遗忘的岛国,最后的诺亚方舟',
          people: '/人',
          address: '马达加斯加',
          days: '8日',
          group: '自然风景',
          total: '累计52人出行',
          img: tm_madagascar,
          icon: cat_4,
          markMap: markMap,
          money: '9,999',
          content: [
            {
              key: 1001,
              desc: `★安齐拉贝：水源之城的神秘火山湖`,
            },
            {
              key: 1002,
              desc: `★穆龙达瓦：天然海滩，壮美日落，人文天堂`,
            },
            {
              key: 1003,
              desc: `★昂达西贝国家公园：与狐猴一起偏偏起舞`,
            },
            {
              key: 1004,
              desc: `★塔那那利佛：马岛历史人文的见证`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: madagascar01,
            },
            {
              id: 'B1002',
              img: madagascar02,
            },
            {
              id: 'B1003',
              img: madagascar03,
            },
          ],
          newTravelItinerary: {
            title: '行程方案',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: '塔那那利佛接机',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '塔那那利佛接机',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: '塔那那利佛',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '穆龙达瓦',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '塔那那利佛',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: '穆龙达瓦',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '穆龙达瓦',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: '穆龙达瓦',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '安齐拉贝',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '穆龙达瓦',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: '安齐拉贝',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '塔那那利佛',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '安齐拉贝',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D6',
                address: [
                  {
                    key: 1001,
                    name: '塔那那利佛',
                  },
                  {
                    key: 1002,
                    name: ' → ',
                  },
                  {
                    key: 1003,
                    name: '昂达西贝保护区',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '塔那那利佛',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D7',
                address: [
                  {
                    key: 1001,
                    name: '昂达西贝保护区（狐猴岛和鳄鱼谷）',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '昂达西贝保护区（狐猴岛和鳄鱼谷）',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D8',
                address: [
                  {
                    key: 1001,
                    name: '昂达西贝保护区',
                  },
                  {
                    key: 1001,
                    name: ' → ',
                  },
                  {
                    key: 1001,
                    name: '塔那那利佛机场送机',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '昂达西贝保护区',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
        {
          id: 1006,
          title: '极点远征，探访企鹅',
          people: '/人',
          address: '南极洲',
          days: '12日',
          group: '自然风景',
          total: '累计12人出行',
          img: tm_antarctica,
          icon: cat_4,
          markMap: markMap,
          money: '28,999',
          content: [
            {
              key: 1001,
              desc: `★赫布里底天空号带您舒适巡游`,
            },
            {
              key: 1002,
              desc: `★随船中文向导伴您无忧南极之旅`,
            },
            {
              key: 1003,
              desc: `★露营南极 与企鹅萌宝共度一夜`,
            },
          ],
          banner: [
            {
              id: 'B1001',
              img: antarctica01,
            },
            {
              id: 'B1002',
              img: antarctica02,
            },
            {
              id: 'B1003',
              img: antarctica03,
            },
          ],
          newTravelItinerary: {
            title: '行程方案',
            list: [
              {
                id: 'D1',
                address: [
                  {
                    key: 1001,
                    name: '乌斯怀亚',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '乌斯怀亚',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D2',
                address: [
                  {
                    key: 1001,
                    name: '乌斯怀亚登船',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '乌斯怀亚登船',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              
              {
                id: 'D3',
                address: [
                  {
                    key: 1001,
                    name: '德雷克海峡',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '德雷克海峡',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D4',
                address: [
                  {
                    key: 1001,
                    name: '德雷克海峡',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '德雷克海峡',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D5',
                address: [
                  {
                    key: 1001,
                    name: '南设得兰群岛:停靠企鹅群居地、海豹栖息地、鸟类群落和鲸鱼活跃区',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '南设得兰群岛',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D6',
                address: [
                  {
                    key: 1001,
                    name: '南设得兰群岛:停靠企鹅群居地、海豹栖息地、鸟类群落和鲸鱼活跃区',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '南设得兰群岛',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D7',
                address: [
                  {
                    key: 1001,
                    name: '南极半岛',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '南极半岛',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D8',
                address: [
                  {
                    key: 1001,
                    name: '南极半岛',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '南极半岛',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D9',
                address: [
                  {
                    key: 1001,
                    name: '南极半岛',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '南极半岛',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D10',
                address: [
                  {
                    key: 1001,
                    name: '德雷克海峡',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '德雷克海峡',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D11',
                address: [
                  {
                    key: 1001,
                    name: '德雷克海峡',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '德雷克海峡',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中晚',
                    icon: d2Icon,
                  }
                ],
              },
              {
                id: 'D12',
                address: [
                  {
                    key: 1001,
                    name: '乌斯怀亚',
                  },
                ],
                descs: [
                  {
                    num: 1001,
                    name: '乌斯怀亚',
                    icon: d1Icon,
                  },
                  {
                    num: 1002,
                    name: '早中',
                    icon: d2Icon,
                  }
                ],
              },
            ],
      
          },
        },
      ],
    },
    inclusiveAll: {
      title: '八顶服务 一价全包',
      list: [
        {
          id: 'E001',
          img: frame_1,
          desc: '机票代订',
        },
        {
          id: 'E002',
          img: frame_2,
          desc: '住宿代订',
        },
        {
          id: 'E003',
          img: frame_3,
          desc: '行程设计',
        },
        {
          id: 'E004',
          img: frame_4,
          desc: '专属路书',
        },
        {
          id: 'E005',
          img: frame_5,
          desc: '旅游签证',
        },
        {
          id: 'E006',
          img: frame_6,
          desc: '旅游保险',
        },
        {
          id: 'E007',
          img: frame_7,
          desc: '随身WIFI',
        },
        {
          id: 'E008',
          img: frame_8,
          desc: '金牌车导',
        },
      ],
      desc: '以上项目包含信息仅供参考，定制服务选择以方案最终确认为准，详情可联系您的旅行策划师。',
    },
    themeTour: {
      title: '主题游',
      list: [
        {
          id: 1001,
          title: '家庭亲子',
          desc: '留一点时间多陪陪家人，收获与众不同的度假体验。',
          img: tm_family,
          icon: cat_1,
        },
        {
          id: 1002,
          title: '蜜月婚礼',
          desc: '满足你对浪漫的一切期，收获100分甜蜜',
          img: tm_honeymoon,
          icon: cat_5,
        },
        {
          id: 1003,
          title: '奔向海岛',
          desc: '徜徉海岛间，潜入深海中。',
          img: tm_island,
          icon: cat_2,
        },
        {
          id: 1004,
          title: '世界宝藏',
          desc: '走入历史与文化的盛宴，感受千年沧桑巨变。',
          img: tm_culture,
          icon: cat_4,
        },
        {
          id: 1005,
          title: '游猎探险',
          desc: '感受广袤与自然的原始意义。',
          img: tm_adventure,
          icon: cat_3,
        },
        {
          id: 1006,
          title: '顶级奢享',
          desc: '全场顶级安排接待，尽享奢华服务。',
          img: tm_luxury,
          icon: cat_6,
        },
      ],
    },
    absNavsData: {
      list: [
        {
          id: 'T001',
          jumpName: 'jumpTravelItinerary',
          name: '行程方案',
        },
        {
          id: 'T002',
          jumpName: 'jumpPricing',
          name: '价格内容',
        },
        {
          id: 'T003',
          jumpName: 'jumpCustomizationProcess',
          name: '定制流程',
        },
        {
          id: 'T004',
          jumpName: 'jumpFAQ',
          name: '常见问题',
        },
        {
          id: 'T005',
          jumpName: 'jumpTBookingInstructions',
          name: '预定须知',
        },
      ],
      enquiry: '免费询问',
    },
    pricingData: {
      title: '价格内容',
      list: [
        {
          id: 'P001',
          img: basicModal1,
          name: '费用包含',
          children: [
            {
              id: '1001',
              name: '费用包含',
            },
          ],
        },
        {
          id: 'P002',
          img: basicModal1,
          children: [
            {
              id: '1001',
              name: '机票代订：',
            },
            {
              id: '1002',
              name: '全程含税机票代订',
            },
          ],
        },
        {
          id: 'P003',
          img: basicModal2,
          children: [
            {
              id: '1001',
              name: '住宿代订：',
            },
            {
              id: '1002',
              name: '全程含税住宿代订',
            },
          ],
        },
        {
          id: 'P004',
          img: basicModal1,
          children: [
            {
              id: '1001',
              name: '服务包括',
            },
          ],
        },
      ]
    },
    pricingMainData: [
      {
        title: {
          name: '1、基础服务',
        },
        list: [
          {
            id: 1001,
            title: '旅行顾问：',
            subTitle: '我们为每位客户提供专属旅行顾问，客户可针对该线路全程免费咨询。',
          },
          {
            id: 1002,
            title: '路书：',
            subTitle: '每一款定制旅行产品，都附有专属路书，路书是无二之旅专为您制作的出国旅游攻略，行程安排、最短线路、租车手续、餐厅推荐等全在书中，解决旅途中99%的问题。它很万能，而且私密。（点击查看路书范例） ',
          },
          {
            id: 1003,
            title: '行程保障：',
            subTitle: '无二之旅提供出行全程保障服务，当您在境外遇到问题，可随时联系您的行后保障团队，或拨打我们的24小时紧急电话。',
          },
          {
            id: 1004,
            title: '行程修改：',
            subTitle: '您可主动要求我们为您修改产品中的住宿代订、景点、活动等元素，满意后再交付全款。',
          },
          {
            id: 1005,
            title: '代办签证：',
            subTitle: '我们可为持有中华人民共和国护照的客户（请确定出行时，护照有效期仍有半年以上）代办目的地签证，如您自备签证，签证费用将从定制旅行产品中减免。 ',
          },
          {
            id: 1006,
            title: 'WiFi租赁：',
            subTitle: '高质量随身WiFi（机场自提）',
          },
          {
            id: 1007,
            title: '境外保险：',
            subTitle: '短期旅游保险（以具体行程为准）',
          },
        ],
      },
      {
        title: {
          name: '2、可选服务',
        },
        list: [
          {
            id: 1001,
            title: '(根据具体情况报价）',
            subTitle: '包车（中文司机/外文司机）、多人团出行（6人以上）、GPS租赁、接送机服务、 海外婚礼、海外拍摄',
          },
        ],
      },
    ],
    expenseDescriptionData: [
      {
        title: {
          name: '费用说明',
        },
        list: [
          {
            id: 1001,
            desc: '本产品起价价格是按双人出行共住一间房核算的最低单人价格。产品价格会根据您所选择的出发日期、出行人数、入住住宿代订房型、航班或交通以及所选附加服务的不同而有所差别。',
          },
          {
            id: 1002,
            desc: '本产品组合中提供机票代订类内容仅为国际段往返机票代订及境外交通机票代订，因客户所在城市无合适的国际航班所造成的国内交通费需要增补差价。',
          },
          {
            id: 1003,
            desc: '部分国家与城市住宿代订需缴纳城市税金，具体金额以住宿代订入住时为准，我司不为代收操作，需直接交予住宿代订前台，敬请悉知。建议届时留取适量现金以便缴纳相关费用。',
          },
          {
            id: 1004,
            desc: '本产品组合中提供的目的地住宿代订费用部分仅包含基本住宿代订预订费（部分住宿代订包含早餐，因住宿代订餐饮、洗衣、理发、电话、饮料、烟酒、付费电视、行李搬运、邮寄等产生的私人费用不在产品价格中。',
          },
          {
            id: 1005,
            desc: '出入境的行李海关课税，及超重行李的托运费、管理费等其他【费用包括】中没有提及的项目所产生的费用，均不包含在产品价格中。',
          },
          {
            id: 1006,
            desc: '在上述“基础服务”之外产生的其他服务费用，均不包含在产品价格中。如有增项需求，需增补差价。',
          },
        ],
      },
    ],
    customizationProcessData: {
      img: pcbg,
      imgM: pcbgn,
      title: {
        name: '定制流程',
        desc: '简单3步，完成定制',
      },
      btnText: '制定旅行',
      texInfoList: [
        {
          id: 'TEXTINFO101',
          icon: serviceIcon_1,
          children: [
            {
              id: 1001,
              name: '免费咨询',
            },
            {
              id: 1002,
              name: '提交旅行需求，旅行顾问将尽快与您联系',
            },
          ],
        },
        {
          id: 'TEXTINFO102',
          icon: serviceIcon_2,
          children: [
            {
              id: 1001,
              name: '沟通行程',
            },
            {
              id: 1002,
              name: '为您设计专属旅行方案，满意后支付费用',
            },
          ],
        },
        {
          id: 'TEXTINFO103',
          icon: serviceIcon_3,
          children: [
            {
              id: 1001,
              name: '预定落实',
            },
            {
              id: 1002,
              name: '完成预定并制作路书，即可轻松自由行',
            },
          ],
        },
      ],
    },
    faqData: {
      title: '常见问题',
      list: [
        {
          id: 1001,
          icon: q1,
          title: 'Q. 鼎盛旅游和其他定制旅行公司，到底有什么区别呢？',
          children: [
            {
              id: 10010,
              desc: 'A.鼎盛旅游的所有定制师都是全职的资深专业定制师，至少在海外旅居两年以上，并且有严格的筛选考核标准。旅行是一件很复杂且慎重的事，我们认为只有全情投入、规范专业，才能提供更好的服务。',
            },
            {
              id: 10021,
              desc: '此外，路书是我们从创立之初就坚持在做的，并且一直在打磨、优化。自2012年以来，每位鼎盛旅游客户都会拥有一本量身打造、独一鼎盛的路书，且路书内行程的翔实程度、内容的专业程度，我们都自信是业界领先的。作为国内成立最早的定制旅行公司之一，鼎盛旅游一直致力于提供有温度的定制旅行服务，相信体验过，就会明白。',
            },
          ],
        },
        {
          id: 1002,
          icon: q2,
          title: 'Q. 你们是怎样收费的？贵吗？',
          children: [
            {
              id: 10010,
              desc: 'A.我们会根据您的旅行需求及预算，为您提供实时核价的线路方案。鼎盛旅游拥有众多资源提供合作方，以及专业全职的旅行顾问和定制师，相信可以为您提供性价比更高的旅行产品。',
            },
            {
              id: 10021,
              desc: '在传统旅游业中，定制一直是奢华昂贵的代名词，而我们认为，这样省心、自由、高性价比的旅行，是所有人都应该享有的。鼎盛旅游始终致力于打造真正平价、真正丰俭由己的定制旅行，让旅行这件美好的事，回归到它该有的样子。',
            },
          ],
        },
        {
          id: 1003,
          icon: q3,
          title: 'Q. 线路价格中都会包含什么？',
          children: [
            {
              id: 10010,
              desc: `A.每一条线路，您都会看到相应的价格包含内容，大致来说包括交通、景点活动、行程设计、专属路书等所有出行必须项。当然不排除有一些受资源所限、只能由您在目的地自行付款的项目，这部分我们会为您预定妥善，但费用是不会算在价格里的。`,
            },
          ],
        },
        {
          id: 1004,
          icon: q4,
          title: 'Q. 定制的行程真的可以完全符合我的需求吗？',
          children: [
            {
              id: 10010,
              desc: `A.从您与我们第一次沟通旅行计划开始，我们就会根据您的需求与喜好，量身设计行程，并在与您的沟通过程中加以调整。让旅行中的每个画面，都是您想要的。`,
            },
            {
              id: 10021,
              desc: `我们坚信，定制旅行的美妙之处，就是让每个人都能在旅途中遇见适合自己的风景。`,
            },
          ],
        },
        {
          id: 1005,
          icon: q5,
          title: 'Q. 可以安排当地的司机与导游吗？',
          children: [
            {
              id: 10010,
              desc: `A.我们的线路费用是不包含司机与导游服务的，但如果您确实有需求，我们可以为您另行安排。当然，作为专业的定制旅行团队，我们还是建议您选择带着路书自由行的方式，既安全放心、又节省费用，还有私密空间，可以深入当地体验探索的乐趣，享受真正的旅行。`,
            },
          ],
        },
        {
          id: 1006,
          icon: q6,
          title: 'Q. 鼎盛旅游的定制旅行适合怎样的人？',
          children: [
            {
              id: 10010,
              desc: `A.其实并没有具体的人群划分，无论是蜜月游、亲子游、家庭游、朋友聚会游…任何一类想旅行的人群都可以选择定制旅行。而且对这样的人群尤其适合哦：`,
            },
            {
              id: 10021,
              desc: `没时间、没精力做攻略，想尽可能地省心省力；`,
            },
            {
              id: 10023,
              desc: `旅行经验/外语能力不足，不希望出行留下遗憾；`,
            },
            {
              id: 10024,
              desc: `比起跟团更喜欢自由行，深入当地，享受真正的旅行；`,
            },
            {
              id: 10025,
              desc: `非常注重旅行性价比。`,
            },
          ],
        },
        {
          id: 1007,
          icon: q7,
          title: 'Q. 路书到底是什么样子呢？带着路书出行真的不用担心吗？',
          children: [
            {
              id: 10010,
              desc: `A. 路书内，每天的行程安排都细化到小时，会在每个环节给予您详细的指导与明确的中英文提示，就像是一位轻便、知识丰富又不会影响私人空间的导游。此外我们还有7*24小时客户出行保障服务，随时守护您的出行安全。`,
            },
            {
              id: 10021,
              desc: `5年来我们服务了数以万计的客户，有独自出行的花甲老人、度蜜月的听障夫妇，也有央视主持人、明星艺人。大家都通过“带着路书自由行”的方式，享受到了既自由又安全的旅行。`,
            },
          ],
        },
      ],
    },
    bookingInstructionsData: {
      title: '预定说明',
      list: [
        {
          id: 1001,
          instruction: {
            icon: basicModal1,
            desc: '* 预定说明',
            innerList: [
              {
                key: '100-1',
                subTitle: {
                  desc: '1. 您应当确保出行人身体条件适合旅游产品的行程安排，并如实填写确认《出境游客健康情况确认单》。',
                  children: null,
                },
              },
              {
                key: '100-2',
                subTitle: {
                  type: false,
                  desc: '2. 请您在预订时务必提供准确、完整的信息（包括但不限于姓名、性别、护照信息、身份证信息、国籍、联系方式、是否成人或儿童等），以免产生预订错误，影响出行。如因您提供错误个人信息而造成的经济损失须您自行承担。',
                  children: null,
                },
              },
              {
                key: '100-3',
                subTitle: {
                  type: false,
                  desc: '3. 如需我社代为办理签证的，您需在确认预定订单后请立即准备签证所需材料，并务必在我社给出的最后截止时间前确保签证材料真实完整的交付 至我社。',
                  children: null,
                },
              },
              {
                key: '100-4',
                subTitle: {
                  type: false,
                  desc: '4. 您在出行期间，应遵循我国和目的地国家及地区的有关规定以及当地公共场所的相关秩序规则，尊重当地的宗教信仰、民族习惯和风土人情，自觉保护当地自然环境。如您违反了中华人民共和国及目的地国家（地区）的有关规定，携带过量货币、物品或违禁品而产生的一切后果须由您自行承担。',
                  children: null,
                },
              },
              {
                key: '100-5',
                subTitle: {
                  type: false,
                  desc: '5. 本旅行产品内容随淡旺季变化调整较为频繁，鼎盛旅游旅游服务平台中的产品介绍、行程安排、价格构成等相关信息仅供参考所用，最终产品内容请以双方确认的为准。',
                  children: null,
                },
              },
              {
                key: '100-6',
                subTitle: {
                  type: false,
                  desc: '6. 本产品组合中预定的目的地住宿代订除非专门标注，否则通常不含餐饮；如需用餐，请至目的地住宿代订现付。本产品组合中预定的目的地住宿代订部分可能需要到到店交付目的地特殊税款或费用，请以住宿代订确认单信息为准。',
                  children: null,
                },
              },
              {
                key: '100-7',
                subTitle: {
                  type: false,
                  desc: '7. 您在确定旅行产品并下单后，我社经过核价提供实时旅行总报价，我社承诺自该报价书面告知您之时可保证该报价24小时有效期。有效期内您可按照该报价购买本旅行产品；若您在有效期内未能支付旅行总费用的，该报价即失效我社需进行二次核价。',
                  children: null,
                },
              },
              {
                key: '100-8',
                subTitle: {
                  type: false,
                  desc: '8. 旅游黄金周、特殊节日等旅游旺季，住宿代订房间等其他旅游项目的预订以款到确认为准，一经确认不得随意变更，如有变更须按照“退改政策”向我社支付服务费。',
                  children: null,
                },
              },
              {
                key: '100-9',
                subTitle: {
                  type: false,
                  desc: '9. 如您在支付全款出发之前取消行程，需自行承担取消行程退订旅游项目所产生的全部实际损失，并按照“退改政策”执行费用退还。',
                  children: null,
                },
              },
              {
                key: '100-10',
                subTitle: {
                  type: false,
                  desc: '10. 如您未能按照约定的行程按时出行或因自身原因导致旅行产品中部分项目未使用的，即视为您自行放弃使用，我社不予退还任何费用。',
                  children: null,
                },
              },
              {
                key: '100-11',
                subTitle: {
                  type: false,
                  desc: '11. 因不可抗力导致无法履行或者继续出行的，我社可以在征得您同意后，对相应出行内容予以变更。因情况紧急无法征求意见或者经征求意见无法得到您同意时，我社可以决定内容的变更，但应当就做出的决定提供必要的证明，由此产生的您经济损失我社应协助您向保险公司索赔。',
                  children: null,
                },
              },
              {
                key: '100-12',
                subTitle: {
                  type: false,
                  desc: '12. 由于出入境管理局、各国领馆、航空公司、保险公司及其他有权机构等不可归责于我社的原因导致您或出行人人身、财产权益受到损害的，包括但不限于航班延误或取消、交通管制、护照延期、签证拒签或未按时出签、不得出入境等，您可及时致电我社，我社在力所能及的范围内予以积极协助，尽量争取减少您的损失，其他事项应由您自行协商解决。',
                  children: null,
                },
              },
              {
                key: '100-13',
                subTitle: {
                  type: false,
                  desc: '13. 为了保护您的权利，针对旅行产品的中的服务事项或旅行期间如有出行困难等需求的，您可拨打我社24小时保障电话。如您在出行过程中对我社提供的服务有投诉需求的，您可拨打我社投诉电话寻求解决。',
                  children: null,
                },
              },
            ],
          },
        },
        {
          id: 1002,
          instruction: {
            icon: basicModal1,
            desc: '退改规则',
            innerList: [
              {
                key: '100-1',
                subTitle: {
                  type: false,
                  desc: '1. 已发生且不可退费用：系指您为购买旅行产品已经发生的费用以及向履行辅助人（如住宿代订、餐饮、交通工具、旅游景点服务提供方）支付且不可退还的费用、手续费等。',
                  children: null,
                },
              },
              {
                key: '100-2',
                subTitle: {
                  type: false,
                  desc: '2. 旅游产品所包含的国际段机票代订，应当按照按照机票代订确认单的退改规则执行。',
                  children: null,
                },
              },
              {
                key: '100-3',
                subTitle: {
                  type: false,
                  desc: '3. 您支付全款后，如您因非我社原因，需修改最终标的旅游产品（包括plus包），对具体旅行元素（指具体的住宿代订、景点、活动、交通等）提出更改需求。因更改旅行元素造成的旅费增加，由您自行承担；旅行元素发生增加、删减、替换、调换顺序的，即视为更改。我社给予您免费更改［2］项的优惠服务，超出部分您应按照人民币150元/项向我社支付服务费（如您已享受该优惠服务的即不再享受）。',
                  children: null,
                },
              },
              {
                key: '100-4',
                subTitle: {
                  type: false,
                  desc: '4. 旅游行程开始前，您可以将本产品中自身的权利义务转让给第三人，我社没有正当理由的不得拒绝（正当理由包括但不限于：已预订的旅行项目不可转让或退改、旅行项目对出行人身份、资格、身体状态等有特殊要求的等），因此增加的费用由您和第三人承担。',
                  children: null,
                },
              },
              {
                key: '100-5',
                subTitle: {
                  type: false,
                  desc: '5. 若您在支付定金且我社已提供出行方案后，提出更改旅行目的地国家的，您需要按照人民币500元/次向我社支付服务费；若您在支付全款后提出更改旅行目的地国家的，即视为新的旅行方案您须另行签订合同支付费用。',
                  children: null,
                },
              },
              {
                key: '100-6',
                subTitle: {
                  type: false,
                  desc: '6. 我社所提供的旅行产品，您可以要求其中旅行元素的内容变更，但不可就其中部分项目要求单独退订。',
                  children: null,
                },
              },
              {
                key: '100-7',
                subTitle: {
                  type: true,
                  desc: '7. 您解除合同：',
                  children: [
                    {
                      key: '100-7-1',
                      type: true,
                      desc: '(1). 您在行程开始前提出解除合同，或按照旅游合同第10.2条第1款约定由我社在行程开始前解除合同的，如果您已支付部分旅行费用或全款的，我社应当扣除已发生且不可退的费用，并按照以下标准扣除违约金：',
                      children: [
                        {
                          type: true,
                          desc: 'A. 解约时间（出行日期前）45天（含45天）以上，支付旅行费用总额10%的违约金；',
                        },
                        {
                          type: true,
                          desc: 'B. 解约时间（出行日期前）45－30天（含30天），支付旅行费用总额15%的违约金；',
                        },
                        {
                          type: true,
                          desc: 'C. 解约时间（出行日期前）30－15天（含15天），支付旅行费用总额20%的违约金；',
                        },
                        {
                          type: true,
                          desc: 'D. 解约时间（出行日期前）15天以内，支付旅行费用总额30%的违约金。',
                        },
                      ],
                    },
                    {
                      key: '100-7-2',
                      type: true,
                      desc: '(2). 您在行程中解除合同，我社应当扣除已发生且不可退的费用，您按照以下违约金计算方式支付违约金：',
                      children: [
                        {
                          type: true,
                          desc: '违约金=旅行费用总额×30%+（旅行费用总额-旅行费用总额×30%）÷旅游总天数×已经出游天数。',
                        },
                      ],
                    },
                    {
                      key: '100-7-3',
                      type: true,
                      desc: '(3). 您未按约定时间到达约定集合出发地点，导致无法正常参加旅游行程的，视为您解除合同；您因自身原因导致机票代订或住宿代订房间全部未使用的，视为您放弃使用并解除合同。由此产生的一切损失或者纠纷由您自行承担。',
                    },
                  ],
                },
              },
              {
                key: '100-8',
                subTitle: {
                  type: true,
                  desc: '8. 我社解除合同：',
                  children: [
                    {
                      key: '100-8-1',
                      type: true,
                      desc: '(1). 若您有以下情形之一的，我社可以解除旅游合同：',
                      children: [
                        {
                          type: true,
                          desc: 'A. 患有传染病等疾病，可能危害其他旅游者健康和安全的；',
                        },
                        {
                          type: true,
                          desc: 'B. 携带危害公共安全的物品且不同意交有关部门处理的；',
                        },
                        {
                          type: true,
                          desc: 'C. 从事违法或者违反社会公德的活动的；',
                        },
                        {
                          type: true,
                          desc: 'D. 从事严重影响其他旅游者权益的活动，且不听劝阻、不能制止的；',
                        },
                        {
                          type: true,
                          desc: 'E. 法律规定的影响合同履行的其他情形。',
                        },
                      ],
                    },
                    {
                      key: '100-8-2',
                      type: true,
                      desc: '(2). 我社在行程开始前提出解除合同的（不包括旅游合同第10.2条第1款约定情形），我社应当退还您所有旅行费用，并按照以下标准向您支付违约金：',
                      children: [
                        {
                          type: true,
                          desc: 'A. 解约时间（出行日期前）45天（含45天）以上，支付旅行费用总额10%的违约金；',
                        },
                        {
                          type: true,
                          desc: 'B. 解约时间（出行日期前）45－30天（含30天），支付旅行费用总额15%的违约金；',
                        },
                        {
                          type: true,
                          desc: 'C. 解约时间（出行日期前）30－15天（含15天），支付旅行费用总额20%的违约金；',
                        },
                        {
                          type: true,
                          desc: 'D. 解约时间（出行日期前）15天以内，支付旅行费用总额30%的违约金。',
                        },
                      ],
                    },
                  ],
                },
              },
              {
                key: '100-9',
                subTitle: {
                  type: true,
                  desc: '* 拒签保障计划',
                  children: [
                    {
                      key: '100-9-1',
                      type: true,
                      desc: '1. “拒签保障计划”系指您委托我社代为办理签证同时购买我社的拒签保障服务（RMB 200元／人／国家，申根国家签证视为一个国家），如您因办理目的地国家的签证被使领馆拒签而无法出行的，其所有已支付的旅行费用（不包括不可退改项目的费用）均可退还。',
                      children: null,
                    },
                    {
                      key: '100-9-2',
                      type: true,
                      desc: '2. 保障时限：自您购买我社的拒签保障服务次日00:00:00起至您实际出行前一日23:59:59止。',
                      children: null,
                    },
                    {
                      key: '100-9-3',
                      type: true,
                      desc: '3. 保障类别：“拒签保障计划”仅适用于旅游签证的申请。',
                      children: null,
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },

  },
  customTravel: {
    bannerData: {
      img: customizedtravel,
      imgM: customizedtravelm,
      customTravel: '定制旅行',
      startCustomizing: '开始定制',
      tailorMade: {
        title: '量身定制的旅行方案',
        desc: '所有行程均可根据您的出行人数、时间、预算和兴趣进行专属定制，鼎盛旅游旅行定制师将为您提供一对一的行程定制服务。',
      }
    },
    pointersContentData: [
      {
        no: '01',
        img: ct_image01,
        title: '时间你定',
        desc: '不用费心做攻略、您只需要決定出發其它的全部都交給我們。',

      },
      {
        no: '02',
        img: ct_image02,
        title: '玩法你定',
        desc: '或独自出行，或与亲友结伴；或轻奢短假、或极地探险；不跟团，才自由、你说了算。',
      },
      {
        no: '03',
        img: ct_image03,
        title: '节奏你定',
        desc: '可以睡到自然醒、也能暴走一整天节奏随心，随走随停。',
      },
    ],
    chooseData: {
      title: '为什么选择鼎盛旅游？',
      desc: '八顶服务  一价全包',
      list: [
        {
          id: 1001,
          text: '机票代订',
          icon: frame_1,
        },
        {
          id: 1002,
          text: '住宿代订',
          icon: frame_2,
        },
        {
          id: 1003,
          text: '行程设计',
          icon: frame_3,
        },
        {
          id: 1004,
          text: '专属路书',
          icon: frame_4,
        },
        {
          id: 1005,
          text: '旅游签证',
          icon: frame_5,
        },
        {
          id: 1006,
          text: '旅游保险',
          icon: frame_6,
        },
        {
          id: 1007,
          text: '随身WIFI',
          icon: frame_7,
        },
        {
          id: 1008,
          text: '金牌车导',
          icon: frame_8,
        },
      ],
    },
    pointersData: {
      img: whychoose_bg,
      imgM: whychoose_bgm,
      list: [
        {
          key: '101',
          title: '真定制',
          desc: '时间、节奏、玩法，你说了算',
        },
        {
          key: '102',
          title: '全包办',
          desc: '机酒、攻略、签证，琐事我们全包',
        },
        {
          key: '103',
          title: '有保障',
          desc: '路线实地勘察，专属管家随叫随到',
        },
      ]
    },
    serviceFlowData: {
      title: '服务流程',
      list: [
        {
          id: 1001,
          icon: customtravelIcon1,
          title: '免费咨询',
          desc: '联系客服，提交旅行需求',
          style: {
            width: '270px'
          },
        },
        {
          id: 1002,
          icon: customtravelIcon2,
          title: '行程设计',
          desc: '定制师为您设计旅行方案，满意后签约付款',
          style: {
            width: '290px'
          },
        },
        {
          id: 1003,
          icon: customtravelIcon3,
          title: '快乐出行',
          desc: '制作路书，踏上旅途',
          style: {
            width: 'auto'
          },
        },
        {
          id: 1004,
          icon: customtravelIcon4,
          title: '全程保障',
          desc: '百万旅行保险，7×24管家服务',
          style: {
            width: '200px'
          },
        },
      ],
    },
  },
  aboutUs: {
    travelWorldEnjoyWhatData: {
      title: '鼎盛旅游，鼎盛世界',
      list: [
        {
          id: 1001,
          text: `${companyName.fullNameZH}成立于2016年，是国内专业的综合性旅游服务商。我们推崇与众不同的度假理念，提供包括入境游、出境游、旅游定制、酒店预订等服务、出行服务。在港澳游、东南亚出境游、日韩出境游上具有较强的竞争优势，一直以优秀的旅游品质，诚信的服务赢得海内外客户的称赞。`,
        },
        {
          id: 1001,
          text: `截至目前，鼎盛旅游拥有覆盖全球120多个国家和地区，服务于不同人群的旅游产品，更推出近百条针对高净值人群的高品质旅行线路，为旅游消费者提供立体化、多渠道的服务。鼎盛团队曾到全球42国实地考察，收藏一手独特资源，至今已为成千上万的人士和家庭提供了私人定制旅行服务。`,
        },
      ],
      info: {
        imgList: [au_image02, au_image01],
        desc: '未来，我们将继续秉承“顾客需求至上，专注品质旅游”的经营理念，凭借深厚的品牌基础和成熟的业务优势，充分挖掘旅游资源为境内外游客提供优质服务，开发更符合市场需求的旅游新产品矩阵，成为规模领先、品质卓越的综合旅游服务商。以优质的文化旅游产品和服务，热忱的态度和专业的服务，为游客带来满意而舒适的旅游体验。',
      }
    },
    businessPhilosophyData: {
      img: philosophy_img,
      imgM: philosophy_imgm,
      title: '经营理念',
      desc: '顾客需求至上，坚持品质服务',
    }
  },
  layouts: {
    headerData: {
      navLinkList: [
        {
          id: 1001,
          title: '定制旅行',
        },
        {
          id: 1002,
          title: '常见问题',
        },
        {
          id: 1003,
          title: '预订说明',
        },
      ],
    },
    footerData: {
      backToTitle: '回到顶部',
      
      websiteRecord: websiteRecord.websiteRecordZH, // 备案->中文
      copyright: websiteRecord.copyrightZH, // 版权->中文
      companyFullName: companyName.fullNameZH, // 全称->中文,
      abbreviation: abbreviation.abbreviationZH, // 简称->中文
      companyAddress: companyAddress.addressZH, // 公司地址->中文
      csh: `24x7 客服热线：`,
      tel: contactInformation.tel, // 联系方式
    }
  },
  serverGroupData: {
      list: [
        {
          id: 1001,
          title: '自由',
          desc: '不用跟团',
          icon: icon1,
          iconm: iconm1,
        },
        {
          id: 1002,
          title: '有保障',
          desc: '24/7小时',
          icon: icon2,
          iconm: iconm2,
        },
        {
          id: 1003,
          title: '省心',
          desc: '不做攻略',
          icon: icon3,
          iconm: iconm3,
        },
      ]
  },
  planTravel: {
    findCaseYouLink: {
      titleOne: '没找到喜欢的案例',
      titleTwo: '开始定制',
      desc: '不妨尝试提交需求单，定制师将为您免费制作专属方案？',
      links: [
        {
          tabTitle: '选择想去的目的地',
        },
        {
          tabTitle: '选择想去的目的地',
        },
        {
          tabTitle: '让我们知道您的旅行偏好',
        },
        {
          tabTitle: '还有什么需求？',
        },
      ]
    },
    domesticTitle: '国内',
    overseasTitle: '境外',
    contactTitle: '联系',
  },
  customProcessSteps: {
    stepsOne: {
      // 目的地
      destination: {
        // 国内
        domestic: {
          name: '目的地',
          placeholder: '请填写目的地',
          list: [
            {
              id: 1001,
              title: '四川',
            },
            {
              id: 1002,
              title: '湖南',
            },
            {
              id: 1003,
              title: '重庆',
            },
            {
              id: 1004,
              title: '湖北',
            },
            {
              id: 1005,
              title: '河北',
            },
            {
              id: 1006,
              title: '三亚',
            },
            {
              id: 1007,
              title: '云南',
            },
          ]
        },
        // 境外
        overseas: {
          content: {
            name: '目的地',
            placeholder: '请填写目的地',
          },
          list: [
            {
              id: 1001,
              title: '曼谷',
            },
            {
              id: 1002,
              title: '普吉岛',
            },
            {
              id: 1003,
              title: '巴厘岛',
            },
            {
              id: 1004,
              title: '东京',
            },
            {
              id: 1005,
              title: '北海道',
            },
            {
              id: 1006,
              title: '首尔',
            },
            {
              id: 1007,
              title: '巴黎',
            },
            {
              id: 1008,
              title: '开罗',
            },
            {
              id: 1009,
              title: '威尼斯',
            },
            {
              id: 1010,
              title: '悉尼',
            },
            {
              id: 1011,
              title: '莫斯科',
            },
            {
              id: 1012,
              title: '伦敦',
            },
          ]
        },
        // 请选择目的地
        message: '*请选择目的地',
      },
      // 天娄
      noOfDays: {
        content: {
          name: '天数',
        },
        list: [
          {
            id: 1001,
            title: '1日游',
          },
          {
            id: 1002,
            title: '2-4日游',
          },
          {
            id: 1003,
            title: '5-7日游',
          },
          {
            id: 1004,
            title: '超过7日游',
          },
        ],
        message: '*请选择目天数',
      },
      // 人娄
      noOfPax: {
        content: {
          name: '人数',
        },
      },
      // 出发日期
      departureDate: {
        content: {
          title: '出发日期',
          placeholder: '选择日期',
        },
        message: '*请选择出发日期',
      }
    },
    stepsTwo: {
      travelRequest: {
        content: {
          title: '旅游需求',
          placeholder: '填写需求',
        },
      },
      travelName: {
        content: {
          title: '姓名',
          placeholder: '填写名字',
        },
        message: '*姓名不能为空',
      },
      mobile: {
        content: {
          title: '电话',
          placeholder: '联络方式',
        },
        messages: {
          title: '*电话号码不能空',
          msg: '*请正确填写电话号码',
        },
      },
    },
    stepsThree: {
      content: {
        title: '提交成功！',
        titleSub: '我们已收到您的咨询、30分钟内旅行顾问将与您联系。',
      },
    },
  }
};
export default zhCN;
